<template>
  <accordion-item
    :headline-level="'h3'"
    :title="$t('tripPlanner.settings.group.interchanges')"
    :accordion-button-text="$t('tripPlanner.settings.group.interchanges')"
    class="accordion__item--flat"
  >
    <template v-if="temporarySettingDiffersFromDefault.maxChanges || temporarySettingDiffersFromDefault.solidStairs" #accordion-header>
      <span><span class="trip-setting--changed">{{ $t('tripPlanner.settings.settingChangedText') }}</span></span>
    </template>
    <template #accordion-content>
      <custom-switch-input
        :legend="$t('tripPlanner.settings.maxChanges.title')"
        :hide-legend="true"
        :group="true"
        :switch-list="maxChangesData"
        @set-optionChanged="changeMaxChanges"
      />

      <custom-switch-input
        :legend="$t('tripPlanner.settings.group.mobilityRestrictions')"
        :hide-legend="true"
        :switch-list="[
          {
            checked: solidStairsNo, // negation
            id: 'solidStairs',
            label: $t('tripPlanner.settings.solidStairs'),
            type: 'checkbox'
          }
        ]"
        @set-optionChanged="changeMobilityRestriction"
      />
    </template>
  </accordion-item>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { tripSettingsStore } from '@/stores/tripsettings'
import AccordionItem from '@/partials/accordion-item.vue'
import CustomSwitchInput from '@/partials/_form/switch-input.vue'

export default {
  name: 'SettingInterchanges',
  components: {
    AccordionItem,
    CustomSwitchInput
  },
  props: {
    maxChanges: {
      type: String || null,
      required: true
    },
    solidStairs: {
      type: Boolean, // we will negate this, because we want a 'no solidStairs' checkbox
      required: true
    },
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(tripSettingsStore, [
      'temporarySettingDiffersFromDefault',
      'possibleOptions'
    ]),

    /**
     * Return array to render maxChanges Options.
     * @function maxChangesData
     */
    maxChangesData () {
      const array = []

      this.possibleOptions?.maxChanges.forEach((level) => {
        array.push({
          checked: (level === this.maxChanges),
          id: `maxChanges-${level}`,
          label: this.$t(`tripPlanner.settings.maxChanges.${level}`),
          type: 'radio',
          value: level
        })
      })

      return array
    },
    solidStairsNo () {
      return !this.solidStairs;
    }
  },
  watch: {
    maxChanges () {
      this.checkIfTheSettingDiffers('maxChanges')
    },
    solidStairs () {
      this.checkIfTheSettingDiffers('solidStairs')
    },
  },
  beforeMount () {
    this.checkIfTheSettingDiffers('maxChanges')
    this.checkIfTheSettingDiffers('solidStairs')
  },
  methods: {
    ...mapActions(tripSettingsStore, [
      'checkIfTemporarySettingDiffersFromDefault'
    ]),
    /**
     * Set maxChanges setting that the trip should use.
     * @function changeMaxChanges
     */
    changeMaxChanges () {
      this.$emit('maxChangesChanged', event.target.value)
    },
    checkIfTheSettingDiffers (settingName) {
      this.checkIfTemporarySettingDiffersFromDefault({
        settingName,
        settingValue: this[settingName]
      })
    },
    /**
     * Set wheelchair, solidStairs, escalators or leastChange setting that the trip should use.
     * Emits one of those events: 'wheelchairChanged', 'solidStairsChanged', 'escalatorsChanged', 'leastChangeChanged'
     * @function changeMobilityRestriction
     */
    changeMobilityRestriction () {
      const setting = event.target.id

      if (setting === 'solidStairs' || setting === 'escalators') {
        // negation because the incoming value is solidStairsNo or escalatorsNo
        this.$emit(`${setting}Changed`, !event.target.checked) // negation
      } else {
        this.$emit(`${setting}Changed`, event.target.checked)
      }
    },
  }
}
</script>
